import { Box, Typography, Link } from "@mui/material"
import TooltipText from "../../../inputComponents/TooltipText"
import { CurrencyTooltips, CurrencyDetailsSubtitles, CurrencyPaths, MechanicType } from "../../../../constants/currency-constants"
import { MultipleSelectOptions } from "../../../selectComponents/MultipleSelectOptions"
import { CurrencyTableItem } from '../../../../types/componentTypes/CurrencyTypes';

import { FormikProps } from "formik";
import React from "react";

interface CurrencySelectorProps {
    formik: FormikProps<any>;
    filteredCurrencies: string[];
    currencyList: string[];
    mechanic: MechanicType;
    isEdit: boolean;
    contentBoxClass?: string;
    providedCurrencies: CurrencyTableItem[];
    selectedCurrencies: string[];
    setCurrencyAllocations: React.Dispatch<React.SetStateAction<Record<number, string>>>;
    setSelectedCurrencies: React.Dispatch<React.SetStateAction<string[]>>;
}

const CurrencySelector = ({formik, filteredCurrencies, currencyList, mechanic, isEdit, contentBoxClass, providedCurrencies, setCurrencyAllocations, selectedCurrencies, setSelectedCurrencies}: CurrencySelectorProps) => {

    const addCurrencyIds = (values: string[]) => {
        const currencyIds = values
            .map((v) => providedCurrencies.find((c) => c.name === v)?.currency_id)
            .filter(Boolean) as string[];

        setSelectedCurrencies([...values]);

        const updatedAllocations: Record<number, string> = {};
        const updatedReduceAmount: any[] = [];

        values.forEach((name, idx) => {
            const currencyId = providedCurrencies.find((c) => c.name === name)?.currency_id;
            if (currencyId) {
                updatedAllocations[idx] = name;
                const existing = formik.values.params.reduceAmount.find(
                    (obj: any) => obj.currencyId === currencyId
                );
                updatedReduceAmount.push(existing || { currencyId: currencyId, amount: null });
            }
        });

        const nextReduceAmount = !updatedReduceAmount.length
            ? [{ currencyId: '', amount: null }]
            : updatedReduceAmount;

        formik.setFieldValue('configurationParameters.currencies', currencyIds, false);
        formik.setFieldValue('params.reduceAmount', nextReduceAmount, false);
        try {
            formik.validateField('tempParams.currencyNames');
        } catch {
            // Some mechanics do not include this path in their yup schema.
        }
        formik.validateField('params.reduceAmount');
        setCurrencyAllocations(updatedAllocations);
    };
    return (
        <Box className={'configCurrencySelector'}>
            <Box className={`currencies-titles`}>
                <Typography variant='body1'>{CurrencyDetailsSubtitles.main[mechanic]}</Typography>
                <TooltipText
                    dataTestId='currency-tooltip'
                    text=''
                    textVariant='body1'
                    tooltip={CurrencyTooltips.Default}
                    styleName={
                        isEdit
                            ? `currencies-tooltip-edit-${mechanic.replace(/ /g, '')}`
                            : `currencies-tooltip-${mechanic.replace(/ /g, '')}`
                    }
                />
            </Box>
            <Box className={contentBoxClass || 'functionality-items'}>
                <MultipleSelectOptions
                    formik={formik}
                    preSelectedValue={isEdit && filteredCurrencies}
                    listOfOptions={currencyList}
                    formikFieldName={'tempParams.currencyNames'}
                    inputLabel='Select Currency'
                    enableAdditional={false}
                    data-testId='currency-tooltip-test'
                    customAction={addCurrencyIds}
                    formControlClass={'currency-multiselect'}
                />
                <Typography variant='body1' className='functionality-items'>
                    Can't find the right currency?&nbsp;
                    <Link href={CurrencyPaths.CreateCurrency}>
                        Create a new currency
                    </Link>
                </Typography>
            </Box>
        </Box>
    )
}

export { CurrencySelector}